import { MiniSeriesCreatorStatus, MiniSeriesCreatorType } from "@/constants/organization";
import ajax from "@/utils/ajax";

// 用户信息：https://mock.corp.kuaishou.com/project/1199/interface/api/1019409
export const USER_INFO_API = "/rest/lightks/miniSeries/pc/teacher/info";

// 是否具有短剧身份
export const USER_QUALIFICATION = "/rest/lightks/miniSeries/pc/creator/info";

// 菜单权限控制 https://mock.corp.kuaishou.com/project/1199/interface/api/1092357
export const USER_STARTUP = "/rest/lightks/miniSeries/pc/startup";

export const WHITE_BOOL = "/rest/lightks/pw/tube/ad/getWhiteListBool";

/** 报表白名单接口 */
export const REPORT_WHITE_LIST = "/rest/lightks/pw/tube/ad/reportWhitelist";

// 是否存在待生效的抽佣比例
export const NEW_COMMISSION = "/rest/lightks/pw/tube/commission/query";

/**
 * 用户信息响应数据
 */

export interface UserInfoData {
    headUrl: string;
    name: string;
    userId: number;
    isWhite?: boolean;
    punished: boolean;
    bizIdentity: number;
}
export const fetchUserInfo = () => {
    return ajax.get<UserInfoData>(USER_INFO_API);
};

/**
 * 是否具有短剧身份
 */
export interface UserQualificationData {
    status: MiniSeriesCreatorStatus;
    msg: string;
    creatorType: MiniSeriesCreatorType;
    organizationName: string;
}
export const fetchUserQualification = () => {
    return ajax.get<UserQualificationData>(USER_QUALIFICATION);
};

/**
 * 是否可以配置虚拟币充值
 */
export interface IStartupData {
    enableMsCoinRecharge: boolean;
    enableSellerSubsidyConfig: boolean;
    // 是否能看到分销入口
    enableMsDistribution: boolean;
    // 身份是母账号or子账号
    enableMasterSubAccount: number;
    // 是否显示 iaa
    enableCreateAdUnlockCourse: boolean;
    // 平台下线
    disableVerticalOperation: boolean;
}
export const fetchUserStartup = () => {
    return ajax.get<IStartupData>(USER_STARTUP);
};

/* 用户是否在白名单中 */
export async function getWhiteBool() {
    const { data } = await ajax.get<boolean>(WHITE_BOOL);
    return data;
}

export async function gerReportWhiteList() {
    const { data } = await ajax.get<Record<string, boolean>>(REPORT_WHITE_LIST);

    return data;
}

/* 用户是否存在待生效的抽佣比例 */
export interface commissionInfo {
    commissionRate: number;
    createTime: number;
    effectiveTime: number;
    expireTime: number;
    role: string;
    sellerId: number;
    status: number;
}
export interface UserEffectingRate {
    commissionInfoVO: commissionInfo;
    firstCommissionEffectiveTime: number;
    effectiveCommissionRate: number;
}
export interface EffectingRateData {
    sellerId: number;
}
export async function getEffectingRate() {
    const { data } = await ajax.get<UserEffectingRate>(NEW_COMMISSION);
    return data;
}

/**
 * 查询母子账号通知
 */
export interface IBindNotice {
    masterKsUid: number;
    nickName: string;
    type: number;
    headUrl: string;
}
export async function queryNotice(): Promise<IBindNotice[]> {
    const { data } = await ajax.get<IBindNotice[]>("/rest/lightks/miniSeries/pc/account/msa/query/notification");
    return data;
}

/**
 * 查询短剧处置通知
 */
export interface IDisposalNotice {
    id: number;
    title: string;
    content: string;
}

export async function getDisposalNotice(): Promise<IDisposalNotice[]> {
    const { data } = await ajax.get<{ notificationList: IDisposalNotice[] }>(
        "/rest/lightks/miniSeries/pc/notification/list"
    );
    return data.notificationList;
}

/**
 * 短剧处置通知已读
 */
export interface IReadParams {
    notificationId: number;
}
export async function getNotificationRead(params: IReadParams) {
    await ajax.get("/rest/lightks/miniSeries/pc/notification/read", undefined, { params });
}
